module.exports = __webpack_public_path__ + "static/media/react-brands.0e9a8031.svg";